/* NESW image reveal (2026-09-30, Jay: "load them in a coherent pattern ... from white up to popping up",
   after aug11). Every CARD photo (homepage rows, collection grid, search, Pair it with, cart suggestions)
   starts white and, once it is both DOWNLOADED and ON SCREEN, fades in (no movement, aug11's curve). Photos that become ready
   in the same moment go in DOM order, 70ms apart, so a row reads left to right instead of popping at
   random. The hero and the product page's gallery are not cards and are never held (LCP).
   Safety: layout/theme.liquid adds html.nesw-reveal in <head>; if this script has not taken over within
   3s, it adds nesw-reveal-off and every photo shows plainly. A hover photo is never touched. */
(function () {
  if (window.__neswReveal) return;
  window.__neswReveal = true;
  var root = document.documentElement;
  if (!('IntersectionObserver' in window)) { root.classList.add('nesw-reveal-off'); return; }
  /* The product page's gallery photos too (Jay 2026-10-02: swiping the photos on a phone had no fade); its
     first photo is eager and never held, so the page's largest paint is unchanged. */
  var SEL = 'img.product-image:not(.product-image--hover):not([loading="eager"]), img.related-product-img:not([loading="eager"]), .nesw-pcg__slide > img:not([loading="eager"]), img.nesw-life__img'; /* eager = first screen, never held */
  var STEP = 90, MAX_STEPS = 8;
  var queue = [], flushing = false;
  function show(img) { img.classList.add('is-in'); }
  function ready(img) { return img.complete && img.naturalWidth > 0; }
  function flush() {
    flushing = false;
    var batch = queue.splice(0);
    batch.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
    batch.forEach(function (img, i) {
      var d = Math.min(i, MAX_STEPS) * STEP;
      img.style.transitionDelay = d + 'ms'; show(img);
      /* clear the stagger once shown, so a hover zoom or a swatch swap is never delayed */
      setTimeout(function () { img.style.transitionDelay = ''; }, d + 1000);
    });
  }
  function enqueue(img) {
    if (img.__nrQueued) return; img.__nrQueued = true;
    queue.push(img);
    if (!flushing) { flushing = true; setTimeout(function () { requestAnimationFrame(flush); }, 40); }
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var img = e.target; io.unobserve(img);
      if (ready(img)) enqueue(img);
      else {
        var done = function () { img.removeEventListener('load', done); img.removeEventListener('error', done); enqueue(img); };
        img.addEventListener('load', done); img.addEventListener('error', done);
      }
    });
  }, { rootMargin: '0px', threshold: 0.12 }); /* on screen for real (aug11 starts as you see it) */
  function watch(scope) {
    var list = (scope.matches && scope.matches(SEL)) ? [scope] : (scope.querySelectorAll ? scope.querySelectorAll(SEL) : []);
    Array.prototype.forEach.call(list, function (img) { if (img.__nrWatched) return; img.__nrWatched = true; io.observe(img); });
  }
  watch(document);
  /* Cards added later (infinite scroll, the drawer's suggestions, a pack swap's new card) join in. */
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) watch(n); }); });
  }).observe(document.body, { childList: true, subtree: true });
  root.classList.add('nesw-reveal-live');
})();

/* SECTIONS, the same way (Jay 2026-09-30: "make basically everything load the same way"). Every page section
   that is BELOW the first screen when the page opens starts invisible and fades in, on the same curve as the
   photos, once 10% of it is on screen. A section already on screen at load is never touched: the header,
   hero, product photo, title, price and buy button show at once (hiding them would delay the page's first
   paint and Google's speed score). Off: the header stack, the cart drawer, anything fixed. Failsafe: the
   classes are added by this script only, so without it nothing is hidden. */
(function () {
  if (window.__neswSecReveal || !('IntersectionObserver' in window)) return;
  window.__neswSecReveal = true;
  function eligible(sec) {
    if (sec.closest('.nesw-headerstack') || /cart-drawer|announcement|header/.test(sec.id)) return false;
    var cs = getComputedStyle(sec); if (cs.position === 'fixed' || cs.display === 'none') return false;
    var r = sec.getBoundingClientRect(); if (r.height < 40) return false;
    return r.top > window.innerHeight; /* below the first screen right now */
  }
  function start() {
    var secs = Array.prototype.filter.call(document.querySelectorAll('#container .shopify-section, .shopify-section-group-footer-group'), eligible);
    if (!secs.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var s = e.target; s.classList.add('nesw-sec-in');
        setTimeout(function () { s.classList.remove('nesw-sec-wait', 'nesw-sec-in'); }, 1100); /* no lingering opacity layer */
      });
    }, { threshold: 0.1 });
    secs.forEach(function (s) { s.classList.add('nesw-sec-wait'); io.observe(s); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
